module.exports = __webpack_public_path__ + "img/invite-member-message.33f6d660.png";